export default "__VITE_ASSET__868259da__"